// extracted by css-extract-rspack-plugin
export default {"error-log-modal":"error-log-modal-tl7Wi3","errorLogModal":"error-log-modal-tl7Wi3"};